import { render, staticRenderFns } from "./role-options.vue?vue&type=template&id=03810940"
import script from "./role-options.vue?vue&type=script&lang=ts"
export * from "./role-options.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports